import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../root';
const FUNCTION_CODE = 'UPDATE_PRODUCTION';

export async function updateProduction(
    userToken: string,
    productionId: string,
    update: Record<string, unknown>
) {
    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/productions/${productionId}/`,
            data: update,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${userToken}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        const errorMessage = () => {
            if (error.response.data.billed_days) {
                return error.response.data.billed_days[0];
            }
            else if (error.response.data.ressource) {
                return error.response.data.ressource[0];
            }
            else if (error.response.data.deal_id) {
                return error.response.data.deal_id[0];
            }
            else {
                return 'La mise à jour de la production a échoué';
            }
        };

        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: errorMessage(),
            error: error
        });
    }
}
